import { takeLatest, put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import * as api from 'data/api';
import { actions } from './slice';
import { transformRefund } from './transformers';
export function* getRefund(_ref) {
  let {
    payload: {
      transactionId
    }
  } = _ref;
  const response = yield* call(api.getRefund, transactionId);

  if ('errors' in response) {
    yield put(actions.getRefundFailure());
    return;
  }

  yield put(actions.getRefundSuccess({
    refund: transformRefund(response.refund)
  }));
}
export default function* saga() {
  yield takeLatest(actions.getRefundRequest.type, getRefund);
}